import { apiFetch } from '@nrdy-marketing-engine/api-fetch';

const updateCart = (cartId: string, cartAttrs: any) =>
  apiFetch(`/v1/carts/${cartId}`, {
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        attributes: cartAttrs,
        id: cartId,
        type: 'carts',
      },
    }),
  });

export default updateCart;
